import { useEphemeralStore } from '@/lib/app-store';
import type { Locale } from '@worldcoo/monolith/core';
import { AnimateNumber } from '@worldcoo/ui/custom/animate-number';
import { useDebounce } from '@worldcoo/ui/hooks/use-debounce';

/**
 * A wrapper around AnimateNumber to trigger the bump effect when a donation is made
 **/
export function PortalAnimateNumber(props: {
	locale: Locale;
	value: number;
	suffix?: string;
	decimalDigits?: number;
	className?: string;
	testId?: string;
}) {
	const donationConfirmed = useEphemeralStore((store) => store.donationConfirmed);
	const setDonationConfirmed = useEphemeralStore((store) => store.setDonationConfirmed);
	const setDonationToConfirm = useEphemeralStore((store) => store.setDonationToConfirm);
	const debouncedValue = useDebounce(props.value, 1_000);
	const bump = donationConfirmed && props.suffix !== '%';

	return (
		<AnimateNumber
			locale={props.locale}
			value={donationConfirmed ? debouncedValue : props.value}
			suffix={props.suffix}
			decimalDigits={props.decimalDigits}
			testId={props.testId}
			animate={bump ? { scale: [1, 1.5, 1.5, 1.5, 1.5, 1] } : undefined}
			transition={bump ? { delay: 1 } : undefined}
			onAnimateComplete={() => {
				if (donationConfirmed) {
					setDonationConfirmed(false);
					setDonationToConfirm(undefined);
				}
			}}
		/>
	);
}
